import { isPlatformBrowser } from "@angular/common";
import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import * as moment from "moment";

import { BookService } from "./shared/book.service";
import { AlertService } from "../shared/alert.service";
import { HttpService } from "../shared/http.service";

@Component({
  selector: "app-book",
  templateUrl: "./book.component.html",
  styleUrls: ["./book.component.scss"]
})
export class BookComponent implements OnInit {
  entity = "book";
  title = "libros";
  books = {};
  booksReady = false;
  actions = true;
  prevPath = "/book/";

  // [api param, column name, isSortable]
  columns = [
    ["title", "Nombre", true],
    ["author", "Autor", true],
    ["editorial", "Editorial", true],
    ["isbn", "ISBN", true],
    ["price", "Precio", true],
    ["lastUpdateBIT", "Última modificación", true]
  ];

  actionColumns = [
    ["highlight", "Destacar", false],
    ["edit", "Editar", true],
    ["delete", "Eliminar", true]
  ];

  downloading = false;

  hasDataTables = false;
  loading = false;

  // getAllBooks filters
  pagination = 25;
  offset = 0;
  query = "";
  sort = "-id"; // to show latest added books
  isbn = 0;
  min_price = 0;
  max_price = 0;
  tags: "";
  actives = null;
  msg = {
    delete: "Libro eliminado correctamente",
    highlight: "Libro destacado correctamente",
    unhighlight: "Libro removido de destacados",
    activateBook: "Item/s activados correctamente",
    downloadError: "Ha ocurrido un error. No fue posible descargar el archivo."
  };

  constructor(
    private bookService: BookService,
    private alertService: AlertService,
    private httpService: HttpService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.getAllBooks();
  }

  delete(value) {
    this.bookService.deleteBook(+value).subscribe(
      updateResponse => {
        this.getAllBooks();
        this.alertService.success(this.msg["delete"]);
      },
      error => {
        this.alertService.error(error);
      }
    );
  }

  highlightBook(value) {
    this.bookService.highlightBook(`${value}`).subscribe(
      highlightResponse => {
        this.getAllBooks();
        this.alertService.success(this.msg["highlight"]);
      },
      error => {
        this.alertService.error(error);
      }
    );
  }

  unHighlightBook(value) {
    this.bookService.unhighlightBook(`${value}`).subscribe(
      highlightResponse => {
        this.getAllBooks();
        this.alertService.success(this.msg["unhighlight"]);
      },
      error => {
        this.alertService.error(error);
      }
    );
  }

  setLimit(value) {
    this.pagination = +value;
    this.getAllBooks();
  }

  setOffset(value) {
    this.offset = +value;
    this.loading = true;
    this.getAllBooks();
  }

  setQuery(value) {
    this.offset = 0;
    this.query = value;
    // TODO:
    // this.booksReady = false;
    this.loading = true;
    this.getAllBooks();
  }

  setOrder(value) {
    this.sort = this.sort === value ? `-${value}` : value;
    this.getAllBooks();
  }

  setISBN(value) {
    this.booksReady = false;
    this.isbn = +value;
    this.getAllBooks();
  }

  activateItems(list) {
    const body = {};
    body["ids"] = list;
    this.httpService.updateRaw("/BulkUpdateBook/", body).subscribe(
      response => {
        this.getAllBooks();
        this.alertService.success(this.msg["activateBook"]);
      },
      error => {
        this.alertService.error(error);
      }
    );
  }

  filterActives(actives) {
    // TODO:
    // this.booksReady = false;
    this.loading = true;
    switch (actives) {
      case "all":
        this.actives = null;
        break;
      case "true":
        this.actives = true;
        break;
      case "false":
        this.actives = false;
        break;
      case "disabled":
        this.getAlldisabledBooks();
        return;
      default:
        return;
    }
    this.getAllBooks();
  }

  getAllBooks() {
    this.bookService
      .getAllBooks(
        this.pagination,
        this.offset,
        this.query,
        this.sort,
        this.isbn,
        this.min_price,
        this.max_price,
        this.tags,
        this.actives
      )
      .subscribe(
        booksResponse => {
          this.books = booksResponse;
          this.booksReady = true;
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
        }
      );
  }

  getAlldisabledBooks() {
    this.bookService
      .getAlldisabledBooks(this.pagination, this.offset, this.query)
      .subscribe(
        booksResponse => {
          this.books = booksResponse;
          this.booksReady = true;
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
        }
      );
  }

  downloadAllBooks() {
    if (isPlatformBrowser(this.platformId)) {
      this.downloading = true;
      const date = moment().format("YYYY-MM-DD_HH-mm-ss");
      this.httpService
        .downloadFile(
          `/Books/All/Download`,
          `Libros${date}.xlsx`,
          this.query,
          this.actives
        )
        .subscribe(
          res => {
            this.downloading = false;
          },
          error => {
            this.alertService.error(this.msg["downloadError"]);
            console.log("ERROR", error);
            this.downloading = false;
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/book/book.component.ts